<main class="overflow-x-hidden">
  <app-landing-hero></app-landing-hero>
  <app-counters></app-counters>

  <div class="glass-effect border-t-0">
    <!-- Showing services -->
    <section #services>
      @defer (hydrate on viewport) {
      <app-services [customItems]="this.items"></app-services>
      }
    </section>

    <!-- Showing industries -->
    <section #industries>
      @defer (on viewport(services); prefetch on idle) {
      <app-industries></app-industries>
      }
    </section>

    <!-- Showing partners -->
    <section #partners>
      @defer (on viewport(services); prefetch on idle) {
      <app-partners></app-partners>
      }
    </section>

    <!-- Showing projects -->
    <section #projects>
      @defer (on viewport(industries); prefetch on idle) {
      <app-projects></app-projects>
      }
    </section>

    <!-- Showing team -->
    <!-- <section #team>
      @defer (on viewport(partners); prefetch on idle) {
      <app-team></app-team>
      }
    </section> -->

    <!-- Showing contact section -->
    <section #contact>
      @defer (on viewport(projects); prefetch on idle) {
      <app-contact-section></app-contact-section>
      }
    </section>

    <!-- Showing feedback -->
    <section #feedback>
      @defer (on idle) {
      <app-feedback></app-feedback>
      }
    </section>
  </div>

  @defer (on idle) {
  <picture>
    <app-animated-background></app-animated-background>
  </picture>
  }
</main>